import { ComponentType } from 'react';

import { IconProps } from '@components/icons';
import { IconBranch } from '@components/icons/branch';
import { IconDate } from '@components/icons/date';
import { IconDecimalFloat } from '@components/icons/decimal-float';
import { IconEmail } from '@components/icons/email';
import { IconFile } from '@components/icons/file';
import { IconIssues } from '@components/icons/issues';
import { IconPerson } from '@components/icons/person';
import { IconPhone } from '@components/icons/phone';
import { IconSelectMultiple } from '@components/icons/select-multiple';
import { IconSelectSingle } from '@components/icons/select-single';
import { IconStatistics } from '@components/icons/statistics';
import { IconTextFormatNumber } from '@components/icons/text-format-number';
import { IconTextLong } from '@components/icons/text-long';
import { IconTextShort } from '@components/icons/text-short';

import { ColumnType } from './types';

export const columnTypeIconMap: Partial<Record<ColumnType, ComponentType<IconProps>>> = {
  email: IconEmail,
  phone_number: IconPhone,
  text: IconTextShort,
  paragraph: IconTextLong,
  single_select: IconSelectSingle,
  multi_select: IconSelectMultiple,
  file: IconFile,
  file_multi: IconFile,
  user: IconPerson,
  progress: IconStatistics,
  date: IconDate,
  boolean: IconBranch,
  number: IconTextFormatNumber,
  decimal: IconDecimalFloat,
  issues: IconIssues,
};

export const ColumnIcon = ({ type, ...rest }: IconProps & { type: ColumnType }) => {
  const Icon = columnTypeIconMap[type];
  if (!Icon) {
    return null;
  }

  return <Icon color="elementPurple50" {...rest} />;
};

export const SmallColumnIcon = ({
  type,
  ...rest
}: Omit<IconProps, 'size'> & { type: ColumnType }) => {
  return <ColumnIcon type={type} size={16} {...rest} />;
};
